import React from "react";
import classes from "./Modal.module.scss";
import classnames from "classnames";
import { ModalProps } from "components/v2/Modals/types/ModalProps";

const NoActionModal: React.FC<ModalProps> = (modalProps) => {
  return modalProps.isOpen ? (
    <div
      className={classnames(
        classes["modal-content"],
        modalProps.additionalClassNames,
      )}
    >
      {modalProps.children}
    </div>
  ) : null;
};
export default NoActionModal;
